/* eslint-disable @typescript-eslint/no-unused-expressions */
import { faStar } from '@fortawesome/free-solid-svg-icons';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import React from 'react';

export default function Stars({
  stars,
  size = '1x',
  color = 'text-warning',
}: {
  stars?: number;
  size?: FontAwesomeIconProps['size'];
  color?: FontAwesomeIconProps['color'];
}) {
  if (!stars) return null;

  const starsArray: any[] = [];
  for (let i = 1; i <= 5; i++) {
    i <= stars
      ? starsArray.push(
          <FontAwesomeIcon
            key={i}
            icon={faStar}
            size={size}
            className={color}
          />,
        )
      : starsArray.push(
          <FontAwesomeIcon
            key={i}
            icon={faStar}
            size={size}
            className="text-gray-300"
          />,
        );
  }

  return <>{starsArray}</>;
}
